// Этап 6, раздел 4 «Тарифы» (docs/PLAN.md) — CRUD напрямую над Plan.
import { type FormEvent, useEffect, useState } from "react";

import { type AdminPlan, ApiError, createPlan, fetchPlans } from "../api/client";
import { PlanRow } from "../components/PlanRow";

const EMPTY_FORM = {
  code: "",
  title: "",
  price: "",
  duration_days: "30",
  device_limit: "5",
  av_tariff_group_id: "",
};

export function PlansScreen() {
  const [plans, setPlans] = useState<AdminPlan[] | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);

  function load() {
    setLoadError(null);
    fetchPlans()
      .then(setPlans)
      .catch((err) => {
        setLoadError(err instanceof ApiError ? err.message : "Не удалось загрузить тарифы");
      });
  }

  useEffect(load, []);

  async function onCreate(event: FormEvent) {
    event.preventDefault();
    setCreating(true);
    setCreateError(null);
    try {
      await createPlan({
        code: form.code.trim(),
        title: form.title.trim(),
        price: Number(form.price),
        duration_days: Number(form.duration_days),
        device_limit: Number(form.device_limit),
        av_tariff_group_id: form.av_tariff_group_id.trim() || null,
      });
      setForm(EMPTY_FORM);
      setShowForm(false);
      load();
    } catch (err) {
      setCreateError(err instanceof ApiError ? err.message : "Не удалось создать тариф");
    } finally {
      setCreating(false);
    }
  }

  return (
    <div className="screen">
      <div className="top-bar" style={{ padding: 0, border: "none", background: "transparent" }}>
        <h2>Тарифы</h2>
        <button className="secondary" onClick={() => setShowForm((v) => !v)}>
          {showForm ? "Отмена" : "+ Новый тариф"}
        </button>
      </div>

      {loadError && <div className="error-text">{loadError}</div>}

      {showForm && (
        <form onSubmit={onCreate} className="card" style={{ marginBottom: 24, display: "grid", gap: 12, gridTemplateColumns: "repeat(3, 1fr)" }}>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Код (уникальный)</label>
            <input required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
          </div>
          <div className="field" style={{ marginBottom: 0, gridColumn: "span 2" }}>
            <label>Название</label>
            <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Цена, ₽</label>
            <input required type="number" min={0} value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} />
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Срок, дней</label>
            <input required type="number" min={1} value={form.duration_days} onChange={(e) => setForm({ ...form, duration_days: e.target.value })} />
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Лимит устройств (1-5)</label>
            <input required type="number" min={1} max={5} value={form.device_limit} onChange={(e) => setForm({ ...form, device_limit: e.target.value })} />
          </div>
          <div className="field" style={{ marginBottom: 0, gridColumn: "span 3" }}>
            <label>av_tariff_group_id (тарифная группа AV-Desk, необязательно)</label>
            <input value={form.av_tariff_group_id} onChange={(e) => setForm({ ...form, av_tariff_group_id: e.target.value })} />
          </div>
          {createError && <div className="error-text" style={{ gridColumn: "span 3", marginBottom: 0 }}>{createError}</div>}
          <div style={{ gridColumn: "span 3" }}>
            <button type="submit" className="primary" disabled={creating}>
              {creating ? "Создаём…" : "Создать тариф"}
            </button>
          </div>
        </form>
      )}

      {plans && (
        <div className="card" style={{ padding: 0, overflow: "auto" }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Код</th>
                <th>Название</th>
                <th>Цена</th>
                <th>Срок, дней</th>
                <th>Устройств</th>
                <th>Пробный</th>
                <th>Статус</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan) => (
                <PlanRow key={plan.id} plan={plan} onChanged={load} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
